'use client';

import { SearchPageContentType } from '@gql';
import { routes } from '@routes';
import { Pagination } from '@components/pagination';

interface SitemapPaginationProps {
  currentPage: number;
  totalPages: number;
  searchType: SearchPageContentType;
}

export function SitemapPagination({
  currentPage,
  totalPages,
  searchType,
}: SitemapPaginationProps) {
  return (
    <Pagination
      onPageChange={(selectedPage) => {
        window.location.replace(
          `${routes.sitemaps(searchType)}?page=${selectedPage}`
        );
      }}
      currentPage={currentPage}
      totalPages={totalPages}
    />
  );
}
